const sortDescByValue = (items = []) => {
  return items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value)).reverse();
};

export default sortDescByValue;